import { template } from "@ember/template-compiler";
import DFloatBody from "float-kit/components/d-float-body";
const DInlineFloat = template(`
  {{#if @instance.expanded}}
    <DFloatBody
      @instance={{@instance}}
      @trapTab={{@trapTab}}
      @mainClass={{@mainClass}}
      @innerClass={{@innerClass}}
      @role={{@role}}
      @portalOutletElement={{@portalOutletElement}}
      @inline={{@inline}}
    >
      {{#if @instance.options.component}}
        <@instance.options.component
          @data={{@instance.options.data}}
          @close={{@instance.close}}
        />
      {{else}}
        {{@instance.options.content}}
      {{/if}}
    </DFloatBody>
  {{/if}}
`, {
  eval() {
    return eval(arguments[0]);
  }
});
export default DInlineFloat;